import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSortAsc = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12.6667 2L15.3333 5.33333H13.3333V13.3333H12V5.33333H10L12.6667 2ZM9.33333 12V13.3333H2V12H9.33333ZM9.33333 7.33333V8.66667H2V7.33333H9.33333ZM8 2.66667V4H2V2.66667H8Z",
		fill: "#616778"
	})
});
export default SvgSortAsc;
